import React, { useEffect, useState } from "react";
import { apiCall } from "../../utils/Api";
import { Button, Checkbox, Col, Divider, Form, Input, Layout, message, Modal, Radio, Row, Select, Space, Spin } from "antd";
import PhoneNumberFormatter from "../../utils/PhoneNumberFormatter";
import PostalCodeFormatter from "../../utils/PostalCodeFormatter";
import conditional from "../../utils/conditional";
import LayoutHeader from "../../layouts/partials/LayoutHeader";
import { ExclamationCircleFilled, LockFilled } from '@ant-design/icons';
import AccountChangePassword from "../../components/AccountChangePassword";
import AccountChangeEmail from "../../components/AccountChangeEmail";
import AccountSave from "../../components/AccountSave";
import { useHistory } from "react-router-dom";
import BusinessDirectoryToggle from "../../components/BusinessDirectoryToggle";
import { useSession } from "../../utils/Session";
export default function MyAccount() {


    const history = useHistory();
    const [session, setSession] = useSession(); 
    const [form] = Form.useForm();
    const [account, setAccount] = useState({})
    const [loading, setLoading] = useState(false);
    const [formError, setFormError] = useState(false);

    const {
        email_address = "",
        first_name = "",
        last_name = "",
        phone_number = "",
        phone_number_type = "home",
        phone_number_ext = "",
        alt_phone_number = "",
        alt_phone_number_type = "cell",
        alt_phone_number_ext = "",
        communication_preference = "email",
        street_address = "",
        street_address_2 = "",
        city = "",
        postal_code = "",
        country = "",
        company = "",
        province = "",
    } = account;

    const [isInstitution, setIsInstitution] = useState((company) ? true : false);
    const [countries, setCountries] = useState([]);
    const [provinces, setProvinces] = useState([])
    const [selectedCountry, setSelectedCountry] = useState(country);
    const [selectedProvince, setSelectedProvince] = useState(province);
    const [modal, contextHolder] = Modal.useModal();



    let hasToken = false;
    if (history.location.search) {
        if (history.location.search.includes("?token=")) {
            hasToken = history.location.search.replace("?token=", "");
        }
    }

    const [token] = useState(hasToken);
    const onEmailChange = (_status, _result) => {

        if (_status) {
            setAccount(_result.user)
            message.success('Email address updated successfully.', 3)
            // message changed
        } else {
            message.error(_result.error, 3)
        }

    }

    const emailChange = () => {
        if (token) {
            apiCall("account/modify", { token: token }, onEmailChange);
        }
    }

    useEffect(emailChange, []);


    const listCountries = () => {
        apiCall("country/getList", {}, (_s, _r) => {
            if (_s) {
                setCountries(_r);
            }
            setLoading(false)
        }, "customer")
    }

    const listProvinces = (_country) => {

        if (!_country) {
            _country = selectedCountry;
        }

        apiCall("province/getList", { "country": _country }, (_s, _r) => {
            if (_s) {
                setProvinces(_r)
            }
        }, "customer")
    }

    useEffect(listCountries, []);
    useEffect(listProvinces, [selectedCountry]);
    const getUser = () => {
        setLoading(true);
        apiCall("account/get", {}, (_s, _r) => {
            if (_s) {
                form.setFieldsValue({
                    first_name: _r.user.first_name,
                    last_name: _r.user.last_name,
                    street_address: _r.user.street_address,
                    street_address_2: _r.user.street_address_2,
                    city: _r.user.city,
                    postal_code: _r.user.postal_code,
                    country: _r.user.country,
                    province: _r.user.province,
                    phone_number: _r.user.phone_number,
                    phone_number_type: _r.user.phone_number_type,
                    phone_number_ext: _r.user.phone_number_ext,
                    alt_phone_number: _r.user.alt_phone_number,
                    alt_phone_number_type: _r.user.alt_phone_number_type,
                    aext: _r.user.alt_phone_number_ext,
                    communication_preference: _r.user.communication_preference,
                });

                setAccount(_r.user);

                listProvinces(_r.user.country);
                setSelectedCountry(_r.user.country);
                setSelectedProvince(_r.user.province);

            } else {
                message.error(_r.error)
            }

        })
    }

    useEffect(getUser, [])


    const postalError = () => {
        let ret = "Valid postal code is required.";
        if (selectedCountry === "Canada") {
            return ret + " eg. A1B 2C3"
        }

        if (selectedCountry === "United States") {
            return ret + " eg. 12345 or 12345-6789"
        }

        return ret;
    }



    const changeEmail = (_modal) => {

        let m = _modal.info({
            icon: null,
            centered: true,
            title: "Change Email",
            width: "auto",
            style: { "padding": "0px" },
            content: <AccountChangeEmail close={() => m.destroy()} email_address={email_address} callback={() => message.success('Email updated.', 2)} />,
            okButtonProps: { style: { "display": "none" } },
        });

    }

    const changePassword = (_modal) => {

        let m = _modal.info({
            icon: null,
            centered: true,
            title: "Change Password",
            width: "auto",
            style: { "padding": "0px" },
            content: <AccountChangePassword close={() => m.destroy()} email_address={email_address} callback={() => message.success('Password updated.', 2)} />,
            okButtonProps: { style: { "display": "none" } },
        });
    }


    const saveAccount = (_form, _modal) => {

        if (_form["aext"]) {
            _form["alt_phone_number_ext"] = _form["aext"];
            delete _form["aext"];
        }

        let m = _modal.info({
            icon: null,
            centered: true,
            title: "Save Changes",
            width: "auto",
            style: { "padding": "0px" },
            content: <AccountSave form={_form} close={() => {m.destroy(); setFormError(false);}} email_address={email_address} callback={() => message.success('Account updated.', 2)} />,
            okButtonProps: { style: { "display": "none" } },
        });
    }




    const drawForm = () => {




        return (
            <>
                <Form form={form} onFinishFailed={() => setFormError(true)} validateTrigger={['onChange', 'onBlur']} onFinish={(v) => saveAccount(v, modal)} layout="vertical">


                    <Row gutter={50}>
                        <Col span={16}>
                            <Form.Item label="Email Address">
                                <Input disabled value={email_address} />
                            </Form.Item>

                            <Form.Item defaultValue={first_name} label={(isInstitution) ? "Main contact first name" : "First name"} name="first_name" rules={[{ message: "First name is required.", required: true }]}>
                                <Input placeholder={(isInstitution) ? "Main contact first name" : "First name"} maxLength={80} />
                            </Form.Item>

                            <Form.Item initialValue={last_name} label={(isInstitution) ? "Main contact last name" : "Last name"} name="last_name" rules={[{ message: "Last name is required."}]}>
                                <Input placeholder={(isInstitution) ? "Main contact last name" : "Last name"} maxLength={80} />
                            </Form.Item>


                            <Form.Item initialValue={street_address} label="Street address" name="street_address" rules={[{ message: "Street address is required.", required: true }]}>
                                <Input aria-label="Street address" placeholder="Street address" maxLength={80} />
                            </Form.Item>

                            <Form.Item initialValue={street_address_2} label="Street address (line 2)" name="street_address_2" rules={[{ required: false }]}>
                                <Input placeholder="Street address (line 2)" maxLength={80} />
                            </Form.Item>




                            <Form.Item initialValue={city} label="City" name="city" rules={[{ message: "City is required.", required: true }]}>
                                <Input placeholder="City" maxLength={80} />
                            </Form.Item>

                            <Form.Item initialValue={country} name="country" label="Country" rules={[{ validateTrigger: "onBlur", validator: (_, value) => (countries.includes(selectedCountry)) ? Promise.resolve() : Promise.reject("no"), message: "Valid country is required.", required: true }]}>
                                <Select aria-label="Select country" showSearch placeholder="Select country" style={{ width: 294 }} onChange={(v) => setSelectedCountry(v)}>
                                    {countries.map((item, index) => {
                                        return (<Select.Option key={index} value={item}>{item}</Select.Option>)
                                    })}
                                </Select>
                            </Form.Item>

                            {((provinces.length > 0) && <Form.Item initialValue={province} label="State / Province" name="province" rules={[{ validateTrigger: "onBlur", validator: (_, value) => (provinces.includes(selectedProvince)) ? Promise.resolve() : (provinces.length > 0) ? Promise.reject("no") : Promise.resolve(), message: "Valid state / province is required.", required: true }]}>
                                <Select disabled={!selectedCountry} aria-label="Select state / province" showSearch placeholder="Select state / province" onChange={(v) => setSelectedProvince(v)} style={{ width: 294 }}>
                                    {provinces.map((item, index) => {
                                        return (<Select.Option key={index} value={item}>{item}</Select.Option>)
                                    })}
                                </Select>
                            </Form.Item>)}

                            {((!provinces.length > 0) && <Form.Item initialValue={province} label="State / Province" name="province" rules={[{ validateTrigger: "onBlur", validator: (_, value) => (provinces.includes(selectedProvince)) ? Promise.resolve() : (provinces.length > 0) ? Promise.reject("no") : Promise.resolve(), message: "Valid state / province is required.", required: false }]}>
                                <Input disabled={!selectedCountry} aria-label="Select state / province" placeholder="Select state / province" style={{ width: 294 }} maxLength={80} />
                            </Form.Item>)}




                            <Form.Item rules={[{ required: true }]} label={<><div style={{ "fontFamily": "SimSun, sans-serif", "color": "#ff4d4f" }}>*</div>&nbsp;Phone number</>}>
                                <Input.Group compact>
                                    <Form.Item noStyle initialValue={phone_number} name="phone_number" rules={[{ message: "Required. Must be a phone number.", pattern: new RegExp(/^[0-9+. \-)(]{10,15}$/g), required: true }]}>
                                        <PhoneNumberFormatter field="phone_number" form={form} country={selectedCountry} style={{ width: "156px" }} inputMode="numeric" placeholder="Phone number" />
                                    </Form.Item>
                                    <Form.Item noStyle initialValue={phone_number_ext} name="phone_number_ext" rules={[{ message: "Must be between 2 and 6 digits", pattern: new RegExp(/^[0-9]{2,6}$/g), required: false }]}>
                                        <Input aria-label="Alternate phone number extension" field="phone_number_ext" style={{ width: '80px' }} maxLength={6} inputMode="numeric" placeholder="Ext." />
                                    </Form.Item>
                                    <Form.Item noStyle initialValue={(["cell", "home", "work"].includes(phone_number_type) ? phone_number_type : "cell")} name="phone_number_type" rules={[{ required: true }]}>
                                        <Select aria-label="Select phone number type" virtual={false} style={{ width: '100px' }} >
                                            <Select.Option value="cell">Cell</Select.Option>
                                            <Select.Option value="home">Home</Select.Option>
                                            <Select.Option value="work">Work</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Input.Group>
                            </Form.Item>

                            <Form.Item rules={[{ required: true }]} label="Alternate phone number">
                                <Input.Group compact>
                                    <Form.Item noStyle rules={[{ message: "Must be a phone number", pattern: new RegExp(/^[0-9+. \-)(]{10,15}$/g) }]} initialValue={alt_phone_number} name="alt_phone_number" >
                                        <PhoneNumberFormatter field="alt_phone_number" form={form} country={selectedCountry} style={{ width: "156px" }} inputMode="numeric" placeholder="Phone number" />
                                    </Form.Item>
                                    <Form.Item noStyle initialValue={alt_phone_number_ext} name="aext" rules={[{ message: "Must be between 2 and 6 digits", pattern: new RegExp(/^[0-9]{2,6}$/g), required: false }]}>
                                        <Input aria-label="Alternate phone number extension" field="aext" style={{ width: '80px' }} maxLength={6} inputMode="numeric" placeholder="Ext." />
                                    </Form.Item>
                                    <Form.Item noStyle initialValue={(["cell", "home", "work"].includes(alt_phone_number_type) ? alt_phone_number_type : "home")} name="alt_phone_number_type">
                                        <Select aria-label="Select alternate phone number type" virtual={false} style={{ width: '100px' }} >
                                            <Select.Option value="home">Home</Select.Option>
                                            <Select.Option value="cell">Cell</Select.Option>
                                            <Select.Option value="work">Work</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Input.Group>
                            </Form.Item>

                            <br />

                            <Form.Item initialValue={communication_preference} label="Preferred method of communication" name="communication_preference" rules={[{ required: true }]}>
                                <Radio.Group buttonStyle="solid">
                                    <Radio.Button value="email">Email</Radio.Button>
                                    <Radio.Button value="phone">Phone</Radio.Button>
                                    <Radio.Button value="text">Text</Radio.Button>
                                </Radio.Group>
                            </Form.Item>



                            <Form.Item initialValue={postal_code} label={(selectedCountry === "United States") ? "Zip code" : "Postal code"} name="postal_code" rules={[{ pattern: (selectedCountry === "Canada") ? new RegExp(/^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/) : (selectedCountry === "United States") ? new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/) : "", message: postalError(), required: true }]}>
                                <PostalCodeFormatter form={form} country={selectedCountry} />
                            </Form.Item>

                            <Form.Item hidden initialValue={isInstitution} name="is_institution" valuePropName="checked" noStyle>
                                <Checkbox />
                            </Form.Item>

                            <Divider dashed />


                        </Col>
                        <Col span={8}>

                            {(session.corp_id === session.contact_id && 
                                <BusinessDirectoryToggle form={form} />
                            )}

                        
                            <div style={{ "position": "sticky", "top": "100px" }}>
                                <p>
                                    For security, you must re-enter your password to make changes to your account.</p>
                                <Button block onClick={() => changeEmail(modal)} icon={<LockFilled aria-hidden />}>Change Email Address</Button>
                                <div className="shim" />
                                <Button block onClick={() => changePassword(modal)} icon={<LockFilled aria-hidden />}>Change Password</Button>
                                <Divider dashed />
                                <Button onClick={() => form.submit()} block icon={<LockFilled aria-hidden />} type="primary" >Save Changes</Button>

                                {(formError && <p style={{ "paddingTop": "15px", "color": "#ff4d4f", "textAlign": "center" }} className="error"><ExclamationCircleFilled /> There was an error. Please review form.</p>)}

                            </div>
                        </Col>
                    </Row>

                    {/* <AccountInsitutionToggle company={company} create={props.create} isInstitution={isInstitution} setIsInstitution={setIsInstitution} /> */}
                </Form>
                {contextHolder}
            </>
        )
    }

    return (
        <Layout className="layout">
            <LayoutHeader
                title={<>My Account</>}
                description={<>Use this page to update your account details.</>} />
            <Layout.Content style={{ "padding": "20px" }}>



                <Spin spinning={loading}>
                    {drawForm()}
                </Spin>
            </Layout.Content>
        </Layout>

    )
}